<div class="page-container">
  <div class="relative page-edge-cut">
    <div class="form-card">
      @if(loadingSrDetail){
      <app-skeleton-loader
        [formLoader]="true"
        [noOfFields]="7"
      ></app-skeleton-loader>
      } @if(!loadingSrDetail){
      <form [formGroup]="form">
        <!-- Membership -->
        @if (step == 1) {
        <section>
          <h1 class="section-heading">
            {{
              isAmendmentCOO
                ? ("COO.SELECT_MEMBERSHIP_TITLE_AMENDMENT" | translate)
                : isGspCertificate
                ? ("COO.SELECT_MEMBERSHIP_TITLE_GSP" | translate)
                : ("COO.SELECT_MEMBERSHIP_TITLE" | translate)
            }}
          </h1>
          <div class="fields-container">
            <div class="field-control">
              <app-active-memberships
                [memberships]="memberships"
                [membershipId]="membershipId"
                (selectMembership)="setSelectedMemberShip($event)"
              ></app-active-memberships>
            </div>

            @if (!membershipId && selectMembershipError) {
            <app-validation-message
              [type]="'error'"
              [content]="{
                title: 'VALIDATION_MSG.ERROR' | translate,
                message: 'VALIDATION_MSG.SELECT_MEMBERSHIP' | translate
              }"
              [showbutton]="false"
            ></app-validation-message>
            }
            <!-- remember option -->
            <div class="field-control pt-5">
              <app-checkbox
                [control]="form.get('remember')"
                [options]="[
                  { value: true, label: ('COO.REMEMBER' | translate) }
                ]"
                (onSelectionChange)="setForFuture($event)"
              />
            </div>
            @if (step == 1) {
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5">
              <app-button
                classesName="btn-edge-cut btn-primary-big mt-6"
                [label]="'BUTTONS.START_NOW' | translate"
                (onBtnClick)="startNow()"
              >
              </app-button>
            </div>
            }
          </div>
        </section>
        }

        <!-- application type -->
        @if (step === 2) {
        <section>
          <div class="selection-header mb-5">
            <h1 class="section-heading">
              {{
                isAmendmentCOO || isGspCertificate
                  ? ("COO.SELECTED_MEMBERSHIP_TITLE" | translate)
                  : ("COO.TYPE_TITLE" | translate)
              }}
            </h1>
            @if(isIssueCOO){
            <p class="px-2">{{ "COO.TYPE_DESC" | translate }}</p>
            }
          </div>
          <!-- membership summary card -->
          <div class="fields-container">
            <div class="field-control">
              <div class="field-control">
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5">
                  @for (m of memberships; track m) { @if (membershipId ===
                  m.CSN) {
                  <div
                    class="relative border border-dc-navy px-6 py-6 text-dc-navy dc-card-stretch"
                  >
                    <!-- Membership Details -->
                    <div class="space-y-4 dc-card-stretch-body">
                      <h3 class="text-2xl font-semibold text-dc-navy min-h-10">
                        {{ m["DC Name English"] }}
                        <!-- {{ m["DC Name Arabic"] }} -->
                      </h3>
                      <div class="mb-4 space-y-4">
                        <div class="dc-card-field">
                          <span class="dc-card-field-label">{{
                            "COO.MEM_NO" | translate
                          }}</span>
                          <span class="dc-card-field-value">{{
                            m["CSN"]
                          }}</span>
                        </div>

                        <div class="dc-card-field">
                          <span class="dc-card-field-label">
                            {{ "COO.TRADE_LIC_NO" | translate }}
                          </span>
                          <span class="dc-card-field-value">
                            {{ m["License Number"] }}
                          </span>
                        </div>
                      </div>
                      <div class="dc-card-stretch-actions">
                        @if(memberships.length > 1){
                        <app-button
                          classesName="btn-edge-cut mt-4 btn-primary-big"
                          [label]="'BUTTONS.CHANGE_MEMBERSHIP' | translate"
                          (onBtnClick)="changeMembership()"
                        >
                        </app-button>
                        }
                      </div>
                    </div>
                    <!-- Bottom navy corner -->
                    <div class="dc-card-corner-blue"></div>
                  </div>
                  } }
                </div>
              </div>
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-5">
              @if (step == 2 && (isIssueCOO || isGspCertificate)) {
              <app-button
                classesName="btn-edge-cut mb-6 btn-primary-big"
                [label]="'BUTTONS.START_NEW_APP' | translate"
                (onBtnClick)="nextStep()"
              >
              </app-button>
              }
            </div>
            <!-- copy grid -->
            @if (step == 2 && (isIssueCOO || isAmendmentCOO)) {

            <div class="border border-dc-navy text-dc-navy">
              <!-- HEADER BAR -->
              <div
                class="flex items-center px-2 py-4 bg-[#F6F9FA] border-b border-dc-navy"
              >
                <h1 class="font-semibold text-xl">
                  {{
                    isAmendmentCOO
                      ? ("COO.COPY_TITLE_AMENDMENT" | translate)
                      : ("COO.COPY_TITLE" | translate)
                  }}
                </h1>

                <!-- Search -->
                <div class="ltr:ml-auto rtl:mr-auto">
                  <div
                    class="flex items-center border border-dc-navy px-3 py-2"
                  >
                    <input
                      type="text"
                      [placeholder]="'COO.SEARCH_BY_COO_NUM' | translate"
                      class="text-sm outline-none w-44"
                      formControlName="searchCooNumber"
                      (blur)="search()"
                      (keyup)="removeSearch($event)"
                    />
                    <i class="fas fa-search text-dc-navy ms-2"></i>
                  </div>
                </div>
              </div>

              <!-- TABLE for COO SR List -->
              <app-table
                [customClass]="'text-dc-navy!'"
                [tableHeadings]="[
                  'COO.SR_Number' | translate,
                  'COO.COO_Number' | translate,
                  'COO.INVOICE' | translate,
                  'COO.DEST' | translate,
                  'COO.DATE' | translate
                ]"
                [dataKeys]="[
                  'SR Number',
                  'DC COO Number',
                  'DC Invoice Number',
                  'DC Final Destination',
                  'DC Created'
                ]"
                [listData]="cooIntegrationList"
                [showActions]="true"
                [loader]="cooListLoading"
                [showPagination]="true"
                [pageSize]="5"
                [totalRecords]="totalCOORecords"
                [otherAction]="true"
                [otherActionText]="
                  (isAmendmentCOO
                    ? 'BUTTONS.APPY_AMENDMENT'
                    : 'BUTTONS.CREATE_COPY'
                  ) | translate
                "
                (otherActionClick)="copyCOOSrToNew($event)"
                [showActionHeading]="false"
                (onPageChange)="onCooListPageChange($event)"
              >
              </app-table>
            </div>
            }
          </div>
        </section>
        }

        <!-- Action for show notes -->
        @if (step >= 3 && srNumber && srInprgoressAwating && !loadingSrDetail) {
        <app-validation-message
          type="info"
          [content]="{
            title: 'SECTION_NOTES' | translate,
            message: 'SECTION_NOTES_DESCRIPTION' | translate
          }"
          [showbutton]="false"
          [buttonText]="'VIEW_NOTES' | translate"
          (onBtnClick)="showNotes = true"
        />
        }

        <!-- shipment -->
        @if (step >= 3) { @if (isAmendmentCOO || isGspCertificate) {
        <section>
          <h1 class="section-heading">
            {{
              (isGspCertificate
                ? "COO.GSP_CERTIFICATE_TITLE"
                : "COO.AMENDMENT_TITLE"
              ) | translate
            }}
          </h1>
          <div class="fields-container">
            <div class="field-control">
              @if (isAmendmentCOO) {
              <app-text-field
                [label]="'COO.COO_Number' | translate"
                [control]="form.get('cooNumber')!"
              ></app-text-field>
              } @if (isGspCertificate) {
              <app-option-field
                [label]="'COO.GSP_AUTHORIZED_PERSON' | translate"
                [control]="form.get('GSPAuthorizedPerson')!"
                [options]="authorizedPersonList"
                [labelKey]="'Name'"
                [valueKey]="'Value'"
              ></app-option-field>

              @if (authorizedPersonList && authorizedPersonList.length < 1 &&
              form.get('GSPAuthorizedPerson')?.touched &&
              form.get('GSPAuthorizedPerson')?.hasError('required')) {
              <app-validation-message
                [type]="'error'"
                [content]="{
                  title: 'VALIDATION_MSG.ERROR' | translate,
                  message:
                    'VALIDATION_MSG.GSP_AUTHORIZED_PERSON_REQUIRED' | translate
                }"
                [showbutton]="false"
              ></app-validation-message>
              } }
            </div>
          </div>
        </section>
        }
        <section>
          <h1 class="section-heading">
            {{ "COO.SHIPMENT_TITLE" | translate }}
          </h1>
          <p class="pl-2">{{ "COO.SHIPMENT_HINT" | translate }}</p>
          <div class="fields-container">
            <h2 class="text-xl font-bold mt-5 mb-5">
              {{ "COO.EXP_DETAILS" | translate }}
            </h2>
            <div class="field-control">
              @if(isPersonalUse){
              <app-text-field
                [label]="'COO.EXP_NAME' | translate"
                [control]="form.get('exporter')!"
                (onSelectionChange)="onExporterChange($event)"
              ></app-text-field>
              }@else {
              <app-option-field
                [label]="'COO.EXP_NAME' | translate"
                [options]="exporters"
                [control]="form.get('exporter')!"
                [labelKey]="'Name'"
                [valueKey]="'Value'"
                (onSelectionChange)="onExporterChange($event)"
              ></app-option-field>
              }
            </div>
            <div class="field-control">
              <app-option-field
                [label]="'COO.EXP_TYPE' | translate"
                [control]="form.get('exporterType')!"
                [lovType]="lookupKey.COO_DC_EXP_TYPE"
                [valueKey]="'Value'"
                [labelKey]="'Value'"
              ></app-option-field>
            </div>
            <!-- Consignee details -->
            <h2 class="text-xl font-bold mt-5 mb-5">
              {{ "COO.CON_DETAILS" | translate }}
            </h2>
            <div class="field-control">
              <app-option-field
                [label]="'COO.SELECT_CONSIGNEE' | translate"
                [options]="consigneeList"
                [control]="form.get('consignee')!"
                [labelKey]="'Name'"
                [valueKey]="'Value'"
                (onSelectionChange)="fillConsigneDetail($event)"
              ></app-option-field>
            </div>

            <!-- list of selected consignee -->
            @if ( selectedConsigneesLists?.length > 0) {
            <app-card-carousel
              [ownerList]="selectedConsigneesLists"
              [showActions]="showActions && selectedConsigneesLists[0].id == 0"
              (onActionClick)="onConsigneeAction($event)"
              [cardFor]="'travelPlan'"
            />
            } @if( showActions){ @if(!isAmendmentCOO){
            <div class="buttons-group mt-5">
              <app-button
                type="button"
                classesName="btn-edge-cut"
                [label]="'BUTTONS.ADD_CONSIGNEE' | translate"
                (onBtnClick)="openAddConsigneeModal()"
              ></app-button>
            </div>
            } }

            <div class="field-control">
              <app-option-field
                [label]="'COO.CONSIGNEE_TYPE' | translate"
                [control]="form.get('consigneeType')!"
                [lovType]="lookupKey.COO_DC_CONSGN_TYPE"
                [valueKey]="'Value'"
                [labelKey]="'Value'"
              ></app-option-field>
            </div>

              @if(!isPersonalUse){
              <!-- Invoice details -->
              <h2 class="text-xl font-bold mt-5 mb-5">
                {{ "COO.INV_DETAILS" | translate }}
              </h2>
              @if (isInvoiceOcrEnabled) {
              <div class="z-60">
                @if(showActions){
                <app-invoice-ocr
                  [allowGspSwitch]="isIssueCOO"
                  (ocrExtracted)="onInvoiceOcrExtracted($event)"
                  (ocrFilesReadyForUpload)="onInvoiceOcrFilesReadyForUpload($event)"
                (ocrCompletedChange)="onInvoiceOcrCompletedChange($event)"
                (manualEntrySelected)="onInvoiceOcrManualEntrySelected()"
                (redoRequested)="onInvoiceOcrRedoRequested()"
                (switchToGsp)="switchToGspAfterOcr()"
                ></app-invoice-ocr>
                }
              </div>
              }
              <div class="field-control">
              <app-text-field
                  [label]="'COO.INV_NUMBER' | translate"
                  [control]="form.get('invoiceNo')!"
                [validationMessages]="invoiceOcrMissingValidationMessages"
                (blur)="onInvoiceNoBlur($event)"
                [maxlength]="50"
              ></app-text-field>
            </div>
            <div class="field-control">
              <!-- <label class="field-label">
                {{ "COO.INV_DATE" | translate }}
              </label> -->
              <app-date
                [label]="'COO.INV_DATE' | translate"
                [control]="form.get('invoiceDate')!"
                [validationMessages]="invoiceOcrMissingValidationMessages"
                [allowedDate]="'past'"
                [noOfPastMonth]="12"
                (onDateChange)="validateInvocieNumber($event)"
              ></app-date>
            </div>

            @if(isDupliateInNumber){
            <app-validation-message
              [type]="'error'"
              [content]="{
                title: 'VALIDATION_MSG.ERROR' | translate,
                message: 'VALIDATION_MSG.INVOICE_NUMBER_DUPLICATE' | translate
              }"
              [showbutton]="false"
            ></app-validation-message>
            }

            <div class="field-control">
              <app-text-field
                [type]="'amount'"
                [control]="form.get('invAmount')!"
                [currencyControl]="form.get('invCurrency')"
                [label]="'COO.INV_AMOUNT' | translate"
                [validationMessages]="invoiceOcrMissingValidationMessages"
                [currencyList]="currencyList"
                (blur)="checkInvoiceAmount($event)"
              ></app-text-field>
            </div>
            <div class="field-control">
              <app-boolean
                [label]="'COO.DIRECT_SHIP' | translate"
                [control]="form.get('directShip')"
                [validationMessages]="invoiceOcrMissingValidationMessages"
                [options]="standardOption"
                (onSelectionChange)="onDirectshipChange($event)"
              ></app-boolean>
            </div>
            @if (form.get('directShip')?.value == fieldValue.YES ||
            form.get('directShip')?.value == fieldValue.YES_AR) {
            <div class="field-control">
              <app-validation-message
                type="info"
                [content]="{
                  message: 'COO.DIRECT_SHIPMENT_NOTE'
                }"
                [showbutton]="false"
              ></app-validation-message>
            </div>
            <div class="field-control">
              <app-option-field
                [label]="'COO.SHIPPING_FROM' | translate"
                [control]="form.get('shippingFrom')!"
                [validationMessages]="invoiceOcrMissingValidationMessages"
                [country]="true"
                [lovType]="lookupKey.COUNTRY"
                (onSelectionChange)="checkForExportCountry($event)"
              ></app-option-field>
            </div>
            } }

            <!-- Personal use -->
            @if(isPersonalUse){
            <div class="field-control">
              <app-text-field
                [type]="'amount'"
                [control]="form.get('invAmount')!"
                [currencyControl]="form.get('invCurrency')"
                [label]="'COO.INV_AMOUNT' | translate"
                [currencyList]="currencyList"
                (blur)="checkInvoiceAmount($event)"
              ></app-text-field>
            </div>
            }

            <div class="field-control">
              <app-option-field
                [label]="'COO.MODE_TRANSPORT' | translate"
                [control]="form.get('transportMode')!"
                [validationMessages]="invoiceOcrMissingValidationMessages"
                [options]="motLovList"
                [valueKey]="'Value'"
                [labelKey]="'Value'"
                (onSelectionChange)="onTransportModeChange($event)"
              ></app-option-field>

              <!-- commented because of hide Sky/air -->
              <!-- <app-option-field
                [label]="'COO.MODE_TRANSPORT' | translate"
                [control]="form.get('transportMode')!"
                [lovType]="lookupKey.COO_DC_TRASNPORT"
                [valueKey]="'Value'"
                [labelKey]="'Value'"
                (onSelectionChange)="onTransportModeChange($event)"
              ></app-option-field> -->
            </div>
            @if(!isPersonalUse){
            <div class="field-control">
              <app-option-field
                [label]="'COO.EXIT_POINT' | translate"
                [control]="form.get('exitPoint')!"
                [validationMessages]="invoiceOcrMissingValidationMessages"
                [lovType]="lookupKey.COO_DC_COO_EXIT_POINT"
                [valueKey]="'Value'"
                [labelKey]="'Value'"
              ></app-option-field>
            </div>
            }
            <div class="field-control">
              <app-option-field
                [label]="'COO.DEST_COUNTRY' | translate"
                [control]="form.get('countryDest')!"
                [country]="true"
                [lovType]="lookupKey.COUNTRY"
                (onSelectionChange)="onDestinationChange($event)"
              ></app-option-field>
            </div>
            @if(!isPersonalUse){
            <div class="field-control">
              <app-option-field
                [label]="'COO.PORT_DISCHARGE' | translate"
                [control]="form.get('portOfDischarge')!"
                [validationMessages]="invoiceOcrMissingValidationMessages"
                [options]="dischargePorts"
                [valueKey]="'Value'"
                [labelKey]="'Value'"
              ></app-option-field>
            </div>
            <div class="field-control">
              <app-date
                [label]="'COO.EXPECTED_DEPARTURE_DATE' | translate"
                [control]="form.get('expectedDepartureDate')!"
                [allowedDate]="'all'"
                [noOfPastMonth]="12"
                [noOfFutureMonth]="12"
                [disabledStartYear]="1940"
              ></app-date>
            </div>
            }
            <div class="field-control">
              <app-text-field
                [type]="'big-text'"
                [label]="'COO.ADDITIONAL_DETAILS' | translate"
                [control]="form.get('additionalDetails')!"
                [maxlength]="1000"
                (blur)="onAdditionalDetailsBlur()"
              ></app-text-field>
              @if (restrictedWordErrorMsg) {
              <app-validation-message
                [type]="'error'"
                [showCloseIcon]="false"
                [content]="{
                  title: 'ALERT.ERROR' | translate,
                  message:
                    'ALERT.RESTRICTED_WORD'
                    | translate : { word: restrictedWordErrorMsg }
                }"
              >
              </app-validation-message>
              }
            </div>
          </div>
        </section>
        }

        <!-- products -->
        @if (step >= 4) {
        <section id="coo-products-section">
          <h1 class="section-heading">
            {{ "COO.PRODUCT_TITLE" | translate }}
          </h1>
          <p class="pl-3">{{ "COO.PRODUCT_SUB" | translate }}</p>
          <div class="fields-container">
            @if( form.get('products')?.touched &&
            form.get('products')?.hasError('required')){
            <app-validation-message
              [type]="'error'"
              [content]="{
                title: 'VALIDATION_MSG.ERROR' | translate,
                message: 'VALIDATION_MSG.ADD_PRODUCT' | translate
              }"
              [showbutton]="false"
            ></app-validation-message>
            }
            @if (showInvoiceOcrProductFallbackGuidance && !loadingOcrProductHsLookup) {
            <app-validation-message
              [type]="'info'"
              [content]="{
                title: 'COO.OCR.PRODUCTS_MANUAL_TITLE' | translate,
                message: 'COO.OCR.PRODUCTS_MANUAL_GUIDANCE' | translate
              }"
              [showbutton]="false"
            ></app-validation-message>
            }
            @if (productValidationErrorKey) {
            <app-validation-message
              [type]="'error'"
              [content]="{
                title: 'VALIDATION_MSG.ERROR' | translate,
                message: productValidationErrorKey | translate
              }"
              [showbutton]="false"
            ></app-validation-message>
            }
            @if (loadingOcrProductHsLookup) {
            <app-skeleton-loader
              [formLoader]="true"
              [noOfFields]="3"
            ></app-skeleton-loader>
            }
            <div class="field-control">
              <!-- products list -->
              @if (products.length > 0) {

              <div class="product-table-wrapper">
                <table class="product-table">
                  <thead>
                    <tr>
                      <th class="w-1/2">
                        {{ "COO.PRODUCT_NAME" | translate }}
                      </th>

                      <th class="w-[20%]">
                        {{ "COO.PRODUCT_COO" | translate }}
                      </th>

                      <th class="w-[20%]">
                        {{ "COO.PRODUCT_UNIT" | translate }} /
                        {{ "COO.PRODUCT_QTY" | translate }}
                      </th>

                      <th class="w-[10%]">
                        <div class="product-table-search">
                          <input
                            type="text"
                            [placeholder]="
                              'COO.SEARCH_PRODUCT_NAME' | translate
                            "
                            formControlName="searchProductText"
                          />
                          <i
                            class="fas fa-search pl-2 cursor-pointer"
                            (click)="search()"
                          ></i>
                        </div>
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    @for (row of paginatedProducts; track $index) {
                    <tr>
                      <td>
                        <span class="font-semibold">{{
                          row.productHSCode
                        }}</span>
                        @if (row.ocrNeedsReview) {
                        <span
                          class="mt-2 inline-flex rounded-full bg-[#fff4e8] px-3 py-1 text-xs font-semibold text-[#c85b00]"
                        >
                          {{ "COO.PRODUCT_VALIDATION.ACTION_REQUIRED" | translate }}
                        </span>
                        }
                        @if (row.ocrValidationErrors?.hsCode) {
                        <span class="mt-1 block text-sm text-red-600">
                          {{
                            row.productHSCode
                              ? ("COO.PRODUCT_VALIDATION.HS_CODE_MATCH_REQUIRED" | translate)
                              : ("COO.PRODUCT_VALIDATION.HS_CODE_REQUIRED" | translate)
                          }}
                        </span>
                        }
                        <span class="block text-gray-600">
                          {{
                            lang == "ar" ? row.productNameAr : row.productNameEn
                          }}
                        </span>
                      </td>

                      <td>
                        {{ row.country }}
                        @if (row.ocrValidationErrors?.country) {
                        <span class="mt-1 block text-sm text-red-600">
                          {{
                            row.country
                              ? ("COO.PRODUCT_VALIDATION.COUNTRY_MATCH_REQUIRED" | translate)
                              : ("COO.PRODUCT_VALIDATION.COUNTRY_REQUIRED" | translate)
                          }}
                        </span>
                        }
                      </td>

                      <td>
                        {{ row.unit }}
                        {{ row.quantity ? "/" : "" }}
                        {{ row.quantity }}
                      </td>

                      <td>
                        @if (showActions) {
                        <div class="flex items-center justify-center gap-2">
                          <a
                            class="text-dc-dark-blue font-semibold underline underline-offset-4 mr-4 cursor-pointer"
                            (click)="editProduct(row, 'edit')"
                            >{{ "BUTTONS.EDIT" | translate }}</a
                          >

                          <button
                            class="text-dc-navy font-semibold"
                            (click)="removeProduct(row)"
                          >
                            <i class="fa-solid fa-xmark"></i>
                          </button>
                        </div>
                        }@else{
                          <div class="flex items-center justify-center gap-2">
                             <a
                            class="text-dc-dark-blue font-semibold underline underline-offset-4 mr-4 cursor-pointer"
                            (click)="editProduct(row, 'view')"
                            >{{ "BUTTONS.VIEW" | translate }}</a
                          >
                          </div>
                        }
                      </td>
                    </tr>
                    }
                  </tbody>
                </table>

                <div class="px-2">
                  <app-pagenation
                    [data]="{
                      currentPage: currentPage,
                      totalPages: totalPages,
                      totalItems: filteredProducts.length
                    }"
                    (pageChangeEvent)="loadPage($event)"
                  ></app-pagenation>
                </div>

                @if (showInvoiceOcrMissingProductCountryWarning) {
                <div class="px-2 pb-2">
                  <app-validation-message
                    [type]="'warning'"
                    [content]="{
                      title: 'COO.PRODUCT_VALIDATION.COUNTRY_INVOICE_WARNING_TITLE' | translate,
                      message: 'COO.PRODUCT_VALIDATION.COUNTRY_INVOICE_WARNING_MESSAGE' | translate
                    }"
                    [showbutton]="false"
                  ></app-validation-message>
                </div>
                }
              </div>

              } @if (showActions) {
              <div class="buttons-group mt-5">
                <div class="flex gap-4">
                  <app-button
                    type="button"
                    classesName="btn-edge-cut btn-primary-small"
                    [label]="'BUTTONS.ADD_PRODUCTS' | translate"
                    (onBtnClick)="openAddProductModal()"
                  ></app-button>
                  @if(showActions && products.length > 4){
                  <app-button
                    type="button"
                    classesName="card-edge-cut-white btn-primary-small"
                    [label]="'BUTTONS.REMOVE_ALL_PRODUCTS' | translate"
                    (onBtnClick)="removeAllProducts()"
                  ></app-button>
                  }
                </div>
              </div>
              }
            </div>
          </div>
        </section>

        }

        <!-- upload documents-->
        @if (step >= 5) {
        <section>
          <h1 class="section-heading">
            {{ "COO.UPLOAD_DOCS" | translate }}
          </h1>
          <div class="px-2 hidden">
            <p [innerHTML]="'DOCUMENT_NOTE' | translate"></p>
          </div>
          @if(loadingDoc){
          <app-skeleton-loader
            [formLoader]="true"
            [noOfFields]="3"
          ></app-skeleton-loader>
          } @if(srFolder && showCooDocs && !loadingDoc){
          <div class="fields-container">
            @for (dt of mainFromSectionDocs; track $index) {
            <div class="field-control">
              <!-- For personal effect to show the download template based on 1.product-> Effect Type -->
              <!-- @if(dt.nameEn == 'COO_Invoice' && isPersonalUse && this.products){
              @if (this.products.length > 0 &&
              this.products[0]?.cooPersonalEffectType){
              <div class="document-template">
                <i class="fas fa-file-download text-xl" aria-hidden="true"></i>
                <div class="flex flex-col gap-1">
                  <span class="text-sm">{{ "TEMPALTE_NOTE" | translate }}</span>
                  <a
                    class="font-semibold hover:text-dc-navy/80"
                    rel="noopener"
                    (click)="
                      downloadTemplateFile(
                        this.products[0]?.cooPersonalEffectType
                      )
                    "
                    >{{ "DOWNLOAD_TEMPLATE" | translate }} ({{
                      this.products[0]?.cooPersonalEffectType
                    }})</a
                  >
                </div>
              </div>
              } } -->
              <app-file
                #fileCmp
                [title]="lang == 'en' ? dt.nameEn : dt.nameAr"
                [control]=""
                [documentType]="dt.nameEn"
                (folderMissing)="openFolder()"
                (onUploadRemove)="handelFileEvent($event, dt.nameEn)"
                [showAction]="shouldShowDocumentActions(dt)"
                [showUploadInput]="shouldShowDocumentUploadInput(dt)"
                [folder]="srFolder"
                [documentServiceType]="documentServiceType.COO"
                [stampLocationRequirement]="dt?.stampLocationRequirement || 'NOT_APPLICABLE'"
              ></app-file>
            </div>
            }

            @if(isIssueCOO || isAmendmentCOO || isGspCertificate){
              <div class="field-control">
                <app-checkbox
                  [control]="form.get('requiredCOO')"
                  [options]="[
                    { value: 'Yes', label: ('COO.FLAG_PROD_Q' | translate) }
                  ]"
                  [disabled]="!showActions"
                >
                </app-checkbox>
              </div>
            }

            @if(isIssueCOO || isAmendmentCOO){
            <div class="field-control">
              <app-checkbox
                [control]="form.get('attestationRequired')"
                [options]="[
                  { value: 'Yes', label: ('COO.ATTEST_BOL_Q' | translate) }
                ]"
                [disabled]="!showActions"
                (onSelectionChange)="makeSignatoryRequired($event)"
              >
              </app-checkbox>
            </div>
            }
          </div>
          }
        </section>
        } @if (step >= 4) {
        <!-- Authorised signatory section  -->
        @if( form.get('attestationRequired')?.value == 'Yes' && ( isIssueCOO ||
        isAmendmentCOO)){
        <section>
          <h1 class="section-heading">
            {{ "ATTESTATION.SELECT_SIGNATORY" | translate }}
          </h1>
          <div class="fields-container">
            @if(!singatoryList || singatoryList.length < 1){
            <div class="field-control">
              <app-validation-message
                type="error"
                [content]="{
                  title: 'ATTESTATION.SIGNATORY_NOT_FOUND' | translate,
                  message: 'ATTESTATION.SIGNATORY_NOT_FOUND_MSG' | translate
                }"
                [buttonText]="'BUTTONS.APPLY_MANAGE_SIGNATORIES' | translate"
                (onBtnClick)="applyForManageSignatories()"
              ></app-validation-message>
            </div>
            } @if(singatoryList && singatoryList.length > 0){
            <div class="field-control">
              <label class="field-label">{{
                "ATTESTATION.SELECT_SIGNATORY" | translate
              }}</label>

              <div class="fields-error-container">
                @if (form.get("signatory")?.errors &&
                !form.get("signatory")?.value) {
                {{ "VALIDATION_MSG.FIELD_REQUIRED" | translate }}
                }
              </div>

              <div class="space-y-2">
                @for (singatory of singatoryList; track singatory) {
                <div>
                  <div class="card-edge-cut relative border-blue">
                    <div class="card-body mb-5">
                      <div class="flex gap-5">
                        <input
                          type="radio"
                          [value]="singatory['DC Related Party Name English']"
                          formControlName="signatory"
                          class="h-5 w-5 text-dc-navy border-gray-300 accent-dc-navy mt-1"
                        />
                        <div class="text-dc-navy!">
                          <span class="font-semibold">
                            {{
                              singatory["DC Related Party Name English"]
                            }}</span
                          >
                          <p class="text-dc-navy! py-2">
                            {{ singatory["DC Related Party Name Arabic"] }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                }
              </div>
            </div>
            }
          </div>
        </section>
        }
        <!-- section for payment method -->
        <section>
          <h1 class="section-heading">
            {{ "SECTION_PAYMENT_METHOD" | translate }}
          </h1>
          <div class="fields-container">
            <div class="field-control">
              <app-boolean
                [label]="'PAYMENT_METHOD' | translate"
                [control]="form.get('paymentMethod')!"
                [lovType]="lookupKey.PAYMENT_METHOD"
                [labelKey]="'Value'"
                [valueKey]="'Value'"
                (onSelectionChange)="onPaymentMethodChange($event)"
              />
            </div>
            @if ( noAdvancePaymentBalance) {
            <app-validation-message
              [content]="{
                title: 'ALERT.ERROR' | translate,
                message: 'ALERT.NO_ADVANCE_PAYMENT_BALANCE' | translate
              }"
              type="error"
            />
            }
          </div>
        </section>
        }
        <div class="fields-container">
        <!-- OCR Consent -->
        @if (isInvoiceOcrEnabled && showConfirmExtractedInvoice && step >= 5) {
          <div class="field-control mb-4">
            <app-checkbox
              [control]="form.get('confirmExtractedInvoice')"
              [options]="[
                {
                  value: true,
                  label: ('COO.CONFIRM_EXTRACTED_INVOICE' | translate)
                }
              ]"
              [disabled]="!showActions"
            >
            </app-checkbox>
          </div>
        }
        <!-- Error Message -->
        <!-- @if (errorMsg) {
        <app-validation-message
          [type]="'error'"
          [showCloseIcon]="false"
          [content]="{
            title: 'ALERT.ERROR' | translate,
            message: errorMsg
          }"
        >
        </app-validation-message>
        } -->
        <!-- Error Message -->
        @if(technicalErrorMsg){
        <app-validation-message
          [type]="'error'"
          [content]="{
            title: 'VALIDATION_MSG.ERROR' | translate,
            message: 'TOAST_MESSAGES.TECHNICAL_ERROR' | translate
          }"
          [showbutton]="false"
        ></app-validation-message>
        }

        <!-- FINAL ACTIONS -->
        @if (step > 2) {       
        <div class="btn-section buttons-group">
          @if (showActions && !formSubmitLoader) { @if(step < 5){
          <app-button
            classesName="btn-edge-cut btn-width-auto"
            [label]="'BUTTONS.NEXT' | translate"
            (onBtnClick)="nextStep()"
          ></app-button>
          } @if (step >= 5) {
          <app-button
            classesName="btn-edge-cut btn-width-auto"
            [label]="'BUTTONS.SUBMIT' | translate"
            (onBtnClick)="nextStep()"
          ></app-button>
          @if(formProgress >=100){
          <app-button
            classesName="card-edge-cut-white btn-width-auto"
            [label]="'BUTTONS.PREVIEW_CERTIFICATE' | translate"
            (onBtnClick)="saveAndClose(true)"
          ></app-button>
          } }
          <app-button
            classesName="card-edge-cut-white btn-width-auto"
            [label]="'BUTTONS.SAVE_CLOSE' | translate"
            (onBtnClick)="saveAndClose()"
          ></app-button>
          } @if(formSubmitLoader){
          <app-button
            type="button"
            classesName="btn-edge-cut btn-width-auto"
            [label]="'PLEASE_WAIT' | translate"
            [disabled]="true"
          ></app-button>
          }
        </div>
        }
        </div>
      </form>
      }
    </div>
  </div>
</div>

@if (showInvoiceOcrInvoiceMismatchModal) {
  <app-confirmation-modal
    [title]="'ocr_invoice_number_mismatch_title'"
    [message]="'ocr_invoice_number_mismatch_message'"
    [confirmLabel]="'BUTTONS.CONTINUE'"
    [cancelLabel]="'BUTTONS.UNDO'"
    [showCancel]="true"
    (confirm)="continueWithInvoiceNumberMismatch()"
    (cancel)="undoInvoiceNumberMismatch()"
  ></app-confirmation-modal>
}

<!-- Form Completion Progress -->
<div>
  <app-service-progress
    [serviceName]="serviceTitle | translate"
    [completePercentage]="formProgress"
  />
</div>

@if (showAmendmentFeeNoticeModal) {
<div class="dc-modal">
  <div class="dc-modal-container min-w-3xs! max-w-[560px]!">
   
    <div class="px-2 py-2">
      <div class="leading-7">
        <p class="mb-4 text-dc-navy!">
          {{ "COO.AMENDMENT_FEE_NOTICE_GREETING" | translate }}
        </p>
        <p class="mb-5 text-dc-navy!">
          {{ "COO.AMENDMENT_FEE_NOTICE_INTRO" | translate }}
        </p>
        <ul class="mb-5 list-disc ps-5 text-dc-navy! font-semibold">
          <li>
            {{ "COO.AMENDMENT_FEE_NOTICE_FIRST_AMENDMENT" | translate }}
          </li>
          <li>
            {{ "COO.AMENDMENT_FEE_NOTICE_SECOND_AMENDMENT" | translate }}
          </li>
        </ul>
        <p class="text-dc-navy!">
          {{ "COO.AMENDMENT_FEE_NOTICE_CLOSING" | translate }}
        </p>
      </div>
      <div class="mt-6 flex justify-end">
        <app-button
          type="button"
          classesName="btn-edge-cut"
          [label]="'BUTTONS.OK' | translate"
          (onBtnClick)="closeAmendmentFeeNoticeModal()"
        ></app-button>
      </div>
    </div>
  </div>
</div>
}

<!-- Add Product Modal -->
@if (addProductModal) {
<div class="dc-modal">
  <div class="dc-modal-container">
    <button
      class="modal-x-button"
      type="button"
      (click)="addProductModal = false"
    >
      <i class="fas fa-close"></i>
    </button>
    <h1 class="section-heading">
      {{ selectedProductMode == 'add' ? ("PRODUCT_FORM.ADD_TITLE" | translate) : ("PRODUCT_FORM.VIEW_TITLE" | translate) }}
    </h1>
    <app-add-carnet-product
      [(isOpen)]="addProductModal"
      [serviceName]="'COO'"
      [viewProductList]="false"
      [allProducts]="[]"
      [product]="selectedProduct"
      [srSubType]="srSubType"
      [MasterHsCodeList]="
        totalHsRecords == masterHSCodeList.length ? masterHSCodeList : []
      "
      [personalEffecType]="selectedPersonalEffecType"
      (onBtnClick)="onProductSubmit($event)"
      [checkDuplicateHSCode]="true"
      [addedProductsList]="products"
      [allowProductActions]="showActions"
      [mode]="selectedProductMode"
    />
  </div>
</div>
} @if (showPreviewModal && previewUrl) {
<div class="dc-modal">
  <div class="dc-modal-container">
    <!-- Modal Overlay -->
    <div class="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div
        class="bg-white w-full max-w-5xl h-[90vh] flex flex-col overflow-hidden"
      >
        <div class="flex-1 overflow-auto bg-gray-50 border-b border-gray-200">
          <div class="min-w-[900px] h-full">
            <iframe
              [src]="previewUrl"
              class="w-full h-full"
              frameborder="0"
            ></iframe>
          </div>
        </div>
        <div class="py-4 flex justify-center bg-white">
          <app-button
            type="button"
            classesName="card-edge-cut-white btn-primary-small"
            [label]="'BUTTONS.CLOSE' | translate"
            (onBtnClick)="closePreviewModal()"
          >
          </app-button>
        </div>
      </div>
    </div>
  </div>
</div>
}

<!-- Add Consingee Modal -->
@if (openConsigneeModal) {
<div class="dc-modal">
  <div class="dc-modal-container">
    <button
      class="modal-x-button"
      type="button"
      (click)="openConsigneeModal = false"
    >
      <i class="fas fa-close"></i>
    </button>
    <h1 class="section-heading">
      {{ "COO.CONSIGNEE_FORM.TITLE" | translate }}
    </h1>
    <app-add-consignee
      [(isOpen)]="openConsigneeModal"
      [selectedConsignee]="selectedConsignee"
      [srSubType]="srSubType"
      (onBtnClick)="onAddConsignee($event)"
    />
  </div>
</div>
} @if (successModal) {
<app-sr-submit-success-modal
  [srNumber]="srNumber"
  (onClose)="closeSuccessModal()"
></app-sr-submit-success-modal>
} @if(showNotes) {
<app-notes
  [srNumber]="srNumber"
  [allowSubmit]="true"
  (onClose)="showNotes = false"
></app-notes>
}
